import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e38456ec")

_pushScopeId("data-v-e38456ec")
const _hoisted_1 = { class: "ai-agent-playground card border h-100 d-flex flex-column" }
const _hoisted_2 = { class: "card-header border-0 pt-4 pb-3" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3" }
const _hoisted_4 = { class: "fw-bold mb-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-7 mb-0" }, "Playground — test how this agent replies", -1)
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "badge badge-light-primary fs-8"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "alert alert-light-warning mx-5 py-3 fs-7 mb-0" }, " Test chat only. Nothing is sent to Messenger or your CRM. ", -1)
const _hoisted_9 = { class: "card-body flex-grow-1 d-flex flex-column pt-4 pb-0 overflow-hidden" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_11 = {
  key: 1,
  class: "alert alert-warning mb-4"
}
const _hoisted_12 = {
  ref: "messagesRef",
  class: "flex-grow-1 overflow-auto pe-2 mb-4",
  style: {"min-height":"280px"}
}
const _hoisted_13 = {
  key: 0,
  class: "text-center py-10 text-muted"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Loading conversation... ")
const _hoisted_16 = {
  key: 1,
  class: "text-muted text-center py-10"
}
const _hoisted_17 = {
  key: 3,
  class: "text-muted fs-7 py-2"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Agent is typing... ")
const _hoisted_20 = { class: "card-footer border-top pt-4 pb-4 px-0" }
const _hoisted_21 = { class: "d-flex justify-content-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InboxMessageBubble = _resolveComponent("InboxMessageBubble")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", null, [
          _createVNode("h4", _hoisted_4, _toDisplayString(_ctx.agent.name), 1),
          _hoisted_5
        ]),
        _createVNode("div", _hoisted_6, [
          (_ctx.creditsRemaining != null)
            ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.formatNumber(_ctx.creditsRemaining)) + " AI credits left ", 1))
            : _createCommentVNode("", true),
          _createVNode("button", {
            type: "button",
            class: "btn btn-sm btn-light",
            disabled: _ctx.resetting || _ctx.sending,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetConversation && _ctx.resetConversation(...args)))
          }, " Reset ", 8, ["disabled"]),
          _createVNode("button", {
            type: "button",
            class: "btn btn-sm btn-light",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, " Close ")
        ])
      ])
    ]),
    _hoisted_8,
    _createVNode("div", _hoisted_9, [
      (_ctx.loadError)
        ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.loadError), 1))
        : _createCommentVNode("", true),
      (_ctx.creditsDepleted)
        ? (_openBlock(), _createBlock("div", _hoisted_11, " AI credits are depleted. Top up to continue testing in the playground. "))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_12, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15
            ]))
          : (!_ctx.messages.length)
            ? (_openBlock(), _createBlock("div", _hoisted_16, " Send a message as if you were a prospect to see how this agent replies. "))
            : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.messages, (message) => {
                return (_openBlock(), _createBlock(_component_InboxMessageBubble, {
                  key: _ctx.messageKey(message),
                  message: message,
                  "contact-name": "You (as prospect)",
                  "assistant-label": _ctx.agent.name
                }, null, 8, ["message", "assistant-label"]))
              }), 128)),
        (_ctx.sending)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19
            ]))
          : _createCommentVNode("", true)
      ], 512),
      _createVNode("div", _hoisted_20, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.draft = $event)),
          class: "form-control form-control-solid mb-3",
          placeholder: "Type a test message as a prospect...",
          disabled: _ctx.sending || _ctx.creditsDepleted,
          onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]), ["enter"]))
        }, null, 40, ["disabled"]), [
          [_vModelText, _ctx.draft]
        ]),
        _createVNode("div", _hoisted_21, [
          _createVNode("button", {
            type: "button",
            class: "btn btn-primary",
            disabled: _ctx.sending || _ctx.creditsDepleted || !_ctx.draft.trim(),
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
          }, _toDisplayString(_ctx.sending ? "Sending..." : "Send"), 9, ["disabled"])
        ])
      ])
    ])
  ]))
})